import React from 'react';
import { Alert, Typography } from '@mui/material';
import { PlayerCardLayout } from '../../components/PlayerCardLayout';

export function FinishedPage({ header, assignedLabel, completionMessage }) {
  return (
    <PlayerCardLayout header={header}>
      <Alert severity="success">{assignedLabel}</Alert>
      <Typography variant="h4">Igra je završena</Typography>
      <Typography>{completionMessage}</Typography>
    </PlayerCardLayout>
  );
}
